var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceRelax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 107,
    viewBox: "0 0 161 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.2657 105.823C96.2511 107.676 113.545 101.5 125.898 90.0733C130.222 86.0586 133.928 79.5733 130.839 74.6321C128.678 71.235 124.354 69.9997 120.648 69.382C99.957 65.0585 78.9569 60.7349 58.2656 56.4114C49.6185 54.5584 39.7361 53.632 35.1038 62.8967C32.3243 68.7644 32.0155 77.1027 35.1038 82.6615C42.5156 95.3233 65.3686 104.279 79.2657 105.823Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5288 93.4712C56.4112 100.265 69.9995 104.589 79.2643 105.515C82.6613 105.824 85.7496 105.824 89.1466 105.515C89.1466 91.927 78.9554 81.1182 66.2936 81.1182C57.6465 81.427 50.2347 86.3682 46.5288 93.4712Z",
    fill: "#FF7192"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8739 9.23902C62.3899 12.1743 62.0499 16.5934 59.1147 19.1094C44.9413 31.258 26.1293 38.6453 7.24993 39.3196C3.3864 39.4576 0.142529 36.4374 0.00454591 32.5739C-0.133437 28.7104 2.88672 25.4665 6.75025 25.3285C22.4593 24.7675 38.2357 18.5665 50.0036 8.47976C52.9389 5.96381 57.358 6.30374 59.8739 9.23902Z",
    fill: "#3D0E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5839 2.00243C95.344 -0.704568 99.7759 -0.661539 102.483 2.09854C116.969 16.8686 135.699 24.2402 153.463 22.8737C157.318 22.5772 160.683 25.4616 160.98 29.3162C161.276 33.1708 158.392 36.5359 154.537 36.8324C132.155 38.5541 109.502 29.2492 92.4878 11.9015C89.7808 9.14138 89.8238 4.70944 92.5839 2.00243Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceRelax);
export default __webpack_public_path__ + "static/media/face_relax.cf4d6846d95db47a23a9e00620cc2e97.svg";
export { ForwardRef as ReactComponent };